import { connect } from 'react-redux'
import { setFilterText, toggleFilter, clearFilter } from '../actions/filter'
import FilterBar from '../components/filter-bar'

const mapStateToProps = state => ({
	filterOptions: state.filterOptions,
	filter: state.filter,
	isLoading: state.posts.isLoading
})

const mapDispatchToProps = (dispatch) => {
	let setFilterTextDelay = 400; //ms
	let filterTextTimeout = null;

	return {
		onInputChange: e => {
			let text = e.target.value;

			clearTimeout(filterTextTimeout);
			filterTextTimeout = setTimeout(() => {
				dispatch(setFilterText(text))
			}, setFilterTextDelay);
		},
		onClickDropdownOption: (name, option) => {
			dispatch(toggleFilter(name, option))
		},
		clearFilter: () => dispatch(clearFilter())
	}
}

const FilterBarContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FilterBar)

export default FilterBarContainer
